
import { ModuleWithProviders } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginProviderComponent } from '@tytapp/user/login-provider/login-provider.component';

import { LoginBounceComponent } from './login-bounce/login-bounce.component';

const routes: Routes = [
    { path: 'login/return', component: LoginBounceComponent },
    { path: 'sign-in-with/:provider', component: LoginProviderComponent }
];

export const routing: ModuleWithProviders<RouterModule> = RouterModule.forChild(routes);